import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const burgerworksListLocationGuestKpisConfigs = {
  googleRating: 'number',
  googleRatingCount: 'number',
  yelpRating: 'number',
  yelpRatingCount: 'number',
  deliveryAvgCustomerReviewScoreDoordash: 'number',
  deliveryReviewedOrderCountDoordash: 'number',
  smgTotalSurveyCount: 'number',
  smgTotalOutstandingSurveyCount: 'number',
  smgOverallSatisfactionRating: 'number',
  smgAccuracyOfOrderRating: 'number',
  smgOrderNotOnTimeRating: 'number',
  smgFriendlinessOfEmployeesRating: 'number',
  smgTasteOfFoodRating: 'number',
  smgOverallCleanlinessRating: 'number',
} as const

const useListLocationGuestKpis = buildMetricValuesHook({
  groupFilterType: 'store',
  metrics: {
    codes: [
      'delivery_avg_customer_review_score_doordash',
      'delivery_reviewed_order_count_doordash',
    ],
    groups: ['Expo Module - Guest', 'Expo Module - Location SMG'],
  },
})

export default useListLocationGuestKpis
